import { getField, updateField } from "vuex-map-fields";
import { httpError } from "@/models/httpError";
import { HTTP } from "@/http-common";
import { createHelpers } from "vuex-map-fields";
const state = {
  rows: [],
  message: new httpError()
};

//getters

const getters = {
  getField
};

//Mutations
const mutations = {
  setProgress(state, message) {
    state.message = message;
  },
  removeRow(state, CmcID) {
    state.rows.filter(function(el) {
      return el.CmcID !== CmcID;
    });
  },
  updateField
};

//ACTIONS
const actions = {
  async getPDF({ dispatch }, id) {
    try {
      var pdf = await HTTP.get("DealerPortal/ViewDealerPDF/" + id, {
        responseType: "blob"
      });
      if (pdf.status == 200) {
        const url = window.URL.createObjectURL(
          new Blob([pdf.data], { type: pdf.contentType })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${id}.contract.pdf`);
        document.body.appendChild(link);
        link.click();
      } else dispatch("reset");
      dispatch(
        "setMessage",
        new httpError({ message: "Retreived OK", httpStatus: 200 })
      );
      return Promise.resolve(pdf.data);
    } catch (err) {
      dispatch(
        "setMessage",
        new httpError({
          message: "Error getting Cmc:" + err,
          httpStatus: 500
        })
      );
      return Promise.reject(err);
    }
  },
  async saveCmc({ commit, dispatch, rootState, state }) {
    try {
      var pdf = await HTTP.post(
        "pdf/AddCmc/" + rootState.orders.rows[0].orderID,
        state.rows
      );
      commit("setCmc", pdf.data);
      dispatch(
        "setMessage",
        new httpError({ message: "saved OK", httpStatus: 200 })
      );
      return Promise.resolve(pdf.data);
    } catch (err) {
      dispatch(
        "setMessage",
        new httpError({ message: "unable to save:" + err, httpStatus: 500 })
      );
      return Promise.reject(err);
    }
  },
  async removeRows({ state, commit, rootState }, newVal) {
    var oldVal = 0 || state.rows.length;
    var rows = [];
    for (var i = oldVal; i > newVal; i--) {
      rows.push(state.rows[i - 1].CmcID);
      commit("deleteRow");
    }
    try {
      var Cmcs = await HTTP.delete(
        "pdf/DeleteCmcFromOrder/" + rootState.orders.rows[0].orderID,
        { data: rows }
      );
      return Promise.resolve(Cmcs);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  setMessage({ commit }, message) {
    commit("setProgress", message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit("setProgress", new httpError());
      }, 2000);
  }
};
export const { mapFields: mapOutputFields } = createHelpers({
  getterType: `register/output/getField`,
  mutationType: `register/output/updateField`
});

export const { mapMultiRowFields: mapOutputMultiRowFields } = createHelpers({
  getterType: "register/output/getField",
  mutationType: "register/output/updateField"
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
